import React from "react";
import cn from "classnames";
import s from "./style.module.css";
import { SubHeading } from "../Elements";
import { ReactComponent as External } from "../Icons/external.svg";
import { ReactComponent as Facebook } from "../Icons/facebook-icon.svg";
import { ReactComponent as Twitter } from "../Icons/twitter-icon.svg";
import { ReactComponent as LinkedIn } from "../Icons/linkedin-icon.svg";

const ExternalLinkList = ({ items = [], title, simple, inline }) => {
  const icons = {
    external: <External />,
    facebook: <Facebook />,
    twitter: <Twitter />,
    linkedin: <LinkedIn />,
  };

  return (
    <>
      <div className={s.mainTitle}>
        {title && <SubHeading>{title}</SubHeading>}
      </div>
      <div className={cn(s.wrap, { [s.simple]: simple, [s.inline]: inline })}>
        {items.map(
          ({ url, title, author, date, description, icon = "external" }, i) => (
            <a
              key={i}
              className={s.link}
              href={url}
              target="_blank"
              rel="noreferrer"
            >
              <span className={s.icon}>{icons[icon]}</span>

              {!inline && (
                <span>
                  {title && <span className={s.title}>{title}</span>}
                  {author && <span className={s.author}>{author}</span>}
                  {date && <span className={s.date}>{date}</span>}
                  {description && (
                    <span className={s.description}>{description}</span>
                  )}
                </span>
              )}
            </a>
          )
        )}
      </div>
    </>
  );
};

export default ExternalLinkList;
